/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Conversations_LoadingInputs */

const en_us2_coach_extra_conversations_loading = /** @type {(inputs: Coach_Extra_Conversations_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading conversations…`)
};

const pt_br2_coach_extra_conversations_loading = /** @type {(inputs: Coach_Extra_Conversations_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando conversas…`)
};

const es_419_coach_extra_conversations_loading = /** @type {(inputs: Coach_Extra_Conversations_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando conversaciones…`)
};

const pt_pt2_coach_extra_conversations_loading = /** @type {(inputs: Coach_Extra_Conversations_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A carregar conversas…`)
};

const fr_fr2_coach_extra_conversations_loading = /** @type {(inputs: Coach_Extra_Conversations_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des conversations…`)
};

const de_de2_coach_extra_conversations_loading = /** @type {(inputs: Coach_Extra_Conversations_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterhaltungen werden geladen…`)
};

const it_it2_coach_extra_conversations_loading = /** @type {(inputs: Coach_Extra_Conversations_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento conversazioni…`)
};

/**
* | output |
* | --- |
* | "Loading conversations…" |
*
* @param {Coach_Extra_Conversations_LoadingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_conversations_loading = /** @type {((inputs?: Coach_Extra_Conversations_LoadingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Conversations_LoadingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_conversations_loading(inputs)
	if (locale === "es-419") return es_419_coach_extra_conversations_loading(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_conversations_loading(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_conversations_loading(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_conversations_loading(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_conversations_loading(inputs)
	return en_us2_coach_extra_conversations_loading(inputs)
});
export { coach_extra_conversations_loading as "coach-extra.conversations_loading" }